import React, { Component } from 'react';
import Label from './Label';
import WriteArea from './WriteArea';

const Notebook = (props) => {
    return (
    <div className="notebook">
        <div className='notebook-label'>
        <Label name='Your Notebook' /> </div>
        <WriteArea he={props.h} value={props.value} controlFuncs={props.controlFunc} />
    </div>
    );
}

export default Notebook


// WEBPACK FOOTER //
// ./src/components/Notebook.js